import { CRUD } from "@/shared/components";
import { RefundsListQuery } from "@/admin/entities/refunds";
import { useRefundsManagement, type RefundRow, RefundsSchemas } from "../model";

/**
 * Реестр возвратов. Только просмотр — создание возврата оформляется
 * кнопкой в списке платежей (RefundButton), редактирования и удаления нет.
 */
export function Refunds() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useRefundsManagement();

  return (
    <CRUD<RefundRow>
      listQuery={RefundsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={RefundsSchemas.filterSchema}
      texts={texts}
      persistFilters
      hideCreateButton
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
